// Studyo Today Backend
// Package studyo.today.subscriptions.v1
// Service definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/subscriptions/v1/subscriptions.proto (package studyo.today.subscriptions.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_subscriptions_v1_resources_entitlement } from "./resources/entitlement_pb.js";
import { file_studyo_today_subscriptions_v1_resources_not_entitled_reason } from "./resources/not_entitled_reason_pb.js";
import { file_studyo_today_subscriptions_v1_resources_product } from "./resources/product_pb.js";
import { file_studyo_today_subscriptions_v1_resources_subscription } from "./resources/subscription_pb.js";

/**
 * Describes the file studyo/today/subscriptions/v1/subscriptions.proto.
 */
export const file_studyo_today_subscriptions_v1_subscriptions = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_studyo_today_subscriptions_v1_resources_entitlement, file_studyo_today_subscriptions_v1_resources_not_entitled_reason, file_studyo_today_subscriptions_v1_resources_product, file_studyo_today_subscriptions_v1_resources_subscription]);

/**
 * Describes the message studyo.today.subscriptions.v1.GetProductsResponse.
 * Use `create(GetProductsResponseSchema)` to create a new message.
 */
export const GetProductsResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 0);

/**
 * Describes the message studyo.today.subscriptions.v1.GetSubscriptionResponse.
 * Use `create(GetSubscriptionResponseSchema)` to create a new message.
 */
export const GetSubscriptionResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 1);

/**
 * Describes the message studyo.today.subscriptions.v1.GetCheckoutUrlRequest.
 * Use `create(GetCheckoutUrlRequestSchema)` to create a new message.
 */
export const GetCheckoutUrlRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 2);

/**
 * Describes the message studyo.today.subscriptions.v1.GetCheckoutUrlResponse.
 * Use `create(GetCheckoutUrlResponseSchema)` to create a new message.
 */
export const GetCheckoutUrlResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 3);

/**
 * Describes the message studyo.today.subscriptions.v1.GetPortalUrlRequest.
 * Use `create(GetPortalUrlRequestSchema)` to create a new message.
 */
export const GetPortalUrlRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 4);

/**
 * Describes the message studyo.today.subscriptions.v1.GetPortalUrlResponse.
 * Use `create(GetPortalUrlResponseSchema)` to create a new message.
 */
export const GetPortalUrlResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 5);

/**
 * Describes the message studyo.today.subscriptions.v1.GetIsPlannerEntitledRequest.
 * Use `create(GetIsPlannerEntitledRequestSchema)` to create a new message.
 */
export const GetIsPlannerEntitledRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 6);

/**
 * Describes the message studyo.today.subscriptions.v1.GetIsPlannerEntitledResponse.
 * Use `create(GetIsPlannerEntitledResponseSchema)` to create a new message.
 */
export const GetIsPlannerEntitledResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 7);

/**
 * Describes the message studyo.today.subscriptions.v1.GetIsSchoolEntitledRequest.
 * Use `create(GetIsSchoolEntitledRequestSchema)` to create a new message.
 */
export const GetIsSchoolEntitledRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 8);

/**
 * Describes the message studyo.today.subscriptions.v1.GetIsSchoolEntitledResponse.
 * Use `create(GetIsSchoolEntitledResponseSchema)` to create a new message.
 */
export const GetIsSchoolEntitledResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 9);

/**
 * Describes the message studyo.today.subscriptions.v1.CreateInvoicedSubscriptionRequest.
 * Use `create(CreateInvoicedSubscriptionRequestSchema)` to create a new message.
 */
export const CreateInvoicedSubscriptionRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 10);

/**
 * Describes the message studyo.today.subscriptions.v1.CreateInvoicedSubscriptionResponse.
 * Use `create(CreateInvoicedSubscriptionResponseSchema)` to create a new message.
 */
export const CreateInvoicedSubscriptionResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_subscriptions, 11);

/**
 * Service definition for the Subscriptions API.
 *
 * @generated from service studyo.today.subscriptions.v1.Subscriptions
 */
export const Subscriptions = /*@__PURE__*/
  serviceDesc(file_studyo_today_subscriptions_v1_subscriptions, 0);

